import moment from 'moment';
import { isNumber, isArray, includes, isObject, get } from 'lodash';

import { datePickerFormat } from '../../../services/ValidationRules';
import {
  getChargerPropertyNameToLabel,
  getChargerOptionsValuesToLabel,
  getChargerSelectFields,
} from '../../../../screens/ChargersList/constants';

import { OPERATOR_NAME, operatorNameToLabel } from '../QueryBuilder/constants';
import StringUtils from '../../../services/StringUtils';
import { nodeConfigurationsValues } from '../utils';

const componentRuleToString = ({ operator, value }) => {
  const componentOperator = StringUtils.isJson(operator) ? JSON.parse(operator) : { name: operator, version: operator };
  const operatorNameLabel = (operatorNameToLabel[componentOperator.name] || '').toLowerCase();
  const operatorVersionLabel = (operatorNameToLabel[componentOperator.version] || '').toLowerCase();

  return `(Package name ${operatorNameLabel} ${value.name} AND Package version ${operatorVersionLabel} ${value.version})`;
};

const getCountryName = (countries, value) => {
  const country = countries.find((item) => item.code === value);

  return country ? country.value : '';
};

const getCountryNameByCode = (countries, value) => {
  if (isArray(value)) {
    return value.map((v) => getCountryName(countries, v)).join(', ');
  }

  return getCountryName(countries, value);
};

const ruleToString = ({ field, operator, value }, config, chargerPropertyNameToLabel) => {
  if (!field || !operator) {
    return null;
  }

  if (field === 'package') {
    return componentRuleToString({ operator, value });
  }

  const operatorLabel = get(operatorNameToLabel, operator, '').toLowerCase();
  const fieldLabel = chargerPropertyNameToLabel[field];
  let ruleValue = '';

  if (field === 'country') {
    const countries = (config && config.COUNTRY) || [];

    ruleValue = getCountryNameByCode(countries, value);
  } else if (includes(getChargerSelectFields(config), field)) {
    const chargerOptionsValuesToLabel = getChargerOptionsValuesToLabel(config);

    if (isArray(value)) {
      ruleValue = value.map((v) => chargerOptionsValuesToLabel[v]);
    } else {
      ruleValue = chargerOptionsValuesToLabel[value];
    }
  } else {
    ruleValue = value;
  }

  if (operator === OPERATOR_NAME.empty || operator === OPERATOR_NAME.notEmpty) {
    return `(${fieldLabel} ${operatorLabel})`;
  }

  if (field === 'customer_id') {
    ruleValue = config.customers.find(({ customerId }) => customerId === value).customerName;

    return `(${fieldLabel} ${operatorLabel} ${ruleValue})`;
  }

  if (isNumber(value)) {
    ruleValue = moment.utc(value).format(datePickerFormat);
  } else if (isObject(value) && value.from && value.to) {
    const from = moment.utc(value.from).format(datePickerFormat);
    const to = moment.utc(value.to).format(datePickerFormat);

    ruleValue = `${from} - ${to}`;
  }

  return `(${fieldLabel} ${operatorLabel} ${ruleValue})`;
};

export const expressSearchQuery = (config, rules, combinator, level = 0, isNodeConfigurationParametersAvailable = false) => {
  const chargerPropertyNameToLabel = isNodeConfigurationParametersAvailable
    ? nodeConfigurationsValues
    : getChargerPropertyNameToLabel(config);

  const rulesStrings = rules
    .map((rule) => {
      if (rule.rules && rule.rules.length > 0) {
        return expressSearchQuery(config, rule.rules, rule.combinator, level + 1, isNodeConfigurationParametersAvailable);
      }

      return ruleToString(rule, config, chargerPropertyNameToLabel);
    })
    .filter((item) => item);

  if (level > 0) {
    return `(${rulesStrings.join(` ${combinator} `)})`;
  }

  return `${rulesStrings.join(` ${combinator} `)}`;
};
